import Vue from "vue";

// initial state
const state = ß.DIAGRAMS;

// mutations
const mutations = {};

const getters = {
    getDiagramComponent: (state, getters) => (key) => {
        if (!key) return {};
        const element = ß.DIAGRAMS[key];
        if (!element) return {};
        return element;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};